"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotCalendarSelected = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotCalendarSelected = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14.433 3.333a1.1 1.1 0 1 0-2.2 0v2.235h-3.9A4.433 4.433 0 0 0 3.9 10v23.333a4.433 4.433 0 0 0 4.434 4.434h23.333a4.433 4.433 0 0 0 4.433-4.434V10.001a4.433 4.433 0 0 0-4.433-4.433h-3.9V3.333a1.1 1.1 0 1 0-2.2 0v2.235H14.433V3.333Zm-6.1 4.435h3.9V10a1.1 1.1 0 0 0 2.2 0V7.768h11.134V10a1.1 1.1 0 0 0 2.2 0V7.768h3.9c1.233 0 2.233 1 2.233 2.233v5.567H6.1V10c0-1.233 1-2.233 2.234-2.233Zm-2.233 10h27.8v15.566c0 1.234-1 2.234-2.233 2.234H8.334c-1.234 0-2.234-1-2.234-2.234V17.768ZM24 20.9a1.1 1.1 0 0 0-1.1 1.1v5a1.1 1.1 0 0 0 1.1 1.1h5a1.1 1.1 0 0 0 1.1-1.1v-5a1.1 1.1 0 0 0-1.1-1.1h-5Zm1.1 5v-2.8h2.8v2.8h-2.8Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotCalendarSelected = SpotCalendarSelected;
SpotCalendarSelected.displayName = "SpotCalendarSelected";